import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { Product } from '../../interfaces/Product/Product';
import { updateProductStock } from '../../api/Product';
import { sharedStyles } from '../../utils/Style';
import NumberInput from '../../components/NumberInput/NumberInput';
import { Waiting } from '../../components/Waiting/Waiting';

interface UpdateProductStockDialogProps {
  product: Product;
  onUpdate: (newProduct: Product) => void;
  open: boolean;
  onClose: () => void;
}

export const UpdateProductStockDialog = (
  props: UpdateProductStockDialogProps,
) => {
  const [loading, setLoading] = useState(false);
  const [stock, setStock] = useState(props.product.quantity);

  useEffect(() => {
    setStock(props.product.quantity);
  }, [props.product]);

  const handleConfirm = () => {
    setLoading(true);
    updateProductStock(props.product.id, stock)
      .then((p) => {
        toast.success('Ürün stoğu başarıyla güncellendi.');
        props.onUpdate(p);
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <Waiting open={loading} />

      <DialogTitle sx={{ ...sharedStyles.h6 }}>
        Ürün Stoğunu Güncelle
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          component='div'
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: 500,
            mt: 1.5,
            gap: 1.5,
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>Ürün</Typography>
          <TextField
            size='small'
            fullWidth
            value={props.product.name}
            disabled
          />

          <Typography sx={{ fontWeight: 600 }}>SKU</Typography>
          <TextField
            size='small'
            fullWidth
            value={props.product.sku}
            disabled
          />

          <Typography sx={{ fontWeight: 600 }}>Barkod</Typography>
          <TextField
            size='small'
            fullWidth
            value={props.product.barcode}
            disabled
          />

          <Typography sx={{ fontWeight: 600 }}>Önceki Stok</Typography>
          <TextField
            size='small'
            fullWidth
            value={props.product.quantity}
            disabled
          />

          <Typography sx={{ fontWeight: 600 }}>Yeni Stok</Typography>
          <NumberInput value={stock} onChange={setStock} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          İptal
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleConfirm}
          sx={sharedStyles.buttonText}
        >
          Onayla
        </Button>
      </DialogActions>
    </Dialog>
  );
};
